import * as React from 'react';
import { Spin as AntdSpin } from 'antd';
import classNames from 'classnames';
import { SpinProps as AntdSpinProps } from 'antd/lib/spin';

import styles from './Spin.module.scss';

interface SpinProps extends AntdSpinProps {
	isLoginSpin?: boolean;
	blurOff?: boolean;
}

const Spin: React.FC<SpinProps> = ({ children, isLoginSpin, blurOff, spinning, ...restProps }) => {
	return (
		<div className={classNames({ [styles.spinBlurOff]: blurOff === true })}>
			{spinning && isLoginSpin && <div className={styles.spinHeader}></div>}

			<AntdSpin
				className={classNames(styles.spin, {
					loginSpin: isLoginSpin,
				})}
				spinning={spinning}
				{...restProps}
			>
				{children}
			</AntdSpin>
		</div>
	);
};

export default Spin;
